import { formatCurrency } from "@angular/common";
import { AfterViewInit, Component, Inject, Input, LOCALE_ID, ViewChild } from "@angular/core";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartService } from "@tylertech/charting-module";
import { IFundTotal } from "@tylertech/tyler-api-types";
import { ChartConfiguration, ChartData, ChartOptions, TooltipItem } from "chart.js";

@Component({
    selector: "fund-total-chart",
    templateUrl: "./fundTotalChart.tmpl.html",
    standalone: false
})
export class FundTotalChartComponent implements AfterViewInit
{
    @Input() readonly byCount: boolean;
    @Input() readonly id: string;
    @Input() readonly funds: ReadonlyArray<IFundTotal>;

    @ViewChild(ChartJsContainerComponent) private readonly chartContainer: ChartJsContainerComponent;

    chartConfig: ChartConfiguration<"pie">;

    constructor(
        @Inject(LOCALE_ID) private readonly locale: string,
        private readonly $chartService: ChartService,
    )
    { }

    ngAfterViewInit(): void
    {
        this.chartConfig = {
            type: "pie",
            // labels: [""],
            data: this.getDataSet(),
            options: this.getOptions(),
        };
    }

    private getDataSet(): ChartData<"pie">
    {
        const [chartData, chartLabels] = this.funds.reduce(
            ([data, labels]: [Array<number>, Array<string>], x: IFundTotal): [Array<number>, Array<string>] =>
            {
                return [
                    data.concat([this.byCount ? x.Count : x.TotalAmount]),
                    labels.concat([x.Fund.Code])
                ];
            },
            [[], []]);

        return {
            labels: chartLabels,
            datasets: [
                {
                    data: chartData,
                    backgroundColor: this.$chartService.getColors(20),
                }
            ],
        };
    }

    private getOptions(): ChartOptions<"pie">
    {
        return {
            responsive: true,
            plugins: {
                tooltip: {
                    callbacks: {
                        label: (tooltipItem: TooltipItem<"pie">): string | string[] =>
                        {
                            const fund = tooltipItem.label;
                            const total = tooltipItem.raw as number;
                            return this.byCount
                                ? `Fund ${fund}`
                                : `Fund ${fund}: ${formatCurrency(total, this.locale, "$")}`;
                        },
                    },
                    backgroundColor: '#ffffff',
                    borderColor: '#767676',
                    borderWidth: 1
                },
                legend: {
                    display: true,
                    position: "right",
                    labels: { boxWidth: 12, color: "#333333" },
                },
            }
        };
    }
}
